import { Grid } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { TableJasa } from "../../Paket/ui/TabJasa";

import { TableItemTransfer } from "pages/Penjualan/Master/Rikjang/tabs/TabBarang";
import {
  ITEM_TYPE_RIKJANG,
  RESET_TAB_MODAL,
} from "pages/Penjualan/Master/Rikjang/constants";

import { addItemById, deleteItemById } from "./helpers";
import { RikjangFormItem } from "pages/Penjualan/Master/Rikjang/form/RikjangFormItem";
function TabRikjang({ formData, setFormData, templateID }) {
  const [formRikjang, setFormRikjang] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleClickSelect = async (row) => {
    setFormRikjang({
      id: "",
      item_type: ITEM_TYPE_RIKJANG,
      item_id: row.id,
      name: row.nama,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const rikjang = formData.rikjang;
      const checkRikjang = rikjang.filter(
        (e) => e.item_id === formRikjang.item_id
      );
      if (checkRikjang.length === 0) {
        if (!isNull(templateID)) {
          const res = await addItemById({
            id_template: templateID,
            item_type: ITEM_TYPE_RIKJANG,
            item_id: formRikjang.item_id,
            qty: formRikjang.qty,
          });
          if (res.state) {
            rikjang.push({
              id: res.data.id,
              id_template: templateID,
              item_type: ITEM_TYPE_RIKJANG,
              item_id: formRikjang.item_id,
              nama_rikjang: formRikjang.name,
              qty: formRikjang.qty,
            });
            setFormData({
              ...formData,
              rikjang,
            });
            defaultToastSuccess(res.message);
          } else {
            defaultToastError(res.message);
          }
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          rikjang.push({
            item_type: ITEM_TYPE_RIKJANG,
            item_id: formRikjang.item_id,
            nama_rikjang: formRikjang.name,
            qty: formRikjang.qty,
          });

          setFormData({
            ...formData,
            rikjang,
          });
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } else {
        defaultToastError("Jasa sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const rikjang = formData.rikjang;
    const checkRikjang = rikjang.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      rikjang: checkRikjang,
    });
    if (!isNull(templateID)) {
      const res = await deleteItemById(row.id);
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  return (
    <div>
      {showModal && (
        <RikjangFormItem
          setShowModal={() => setShowModal(false)}
          form={formRikjang}
          setForm={setFormRikjang}
          disabled={disabled}
          handleSubmit={handleSubmit}
        />
      )}
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableJasa
            url='/master/rikjang/ms_rikjang/listMsRikjang'
            handleClickSelect={handleClickSelect}
            title='Daftar Rikjang'
          />
        </Grid>

        <Grid item sm={6}>
          <TableItemTransfer
            rows={formData.rikjang}
            clickDelete={clickDelete}
            filter='nama_rikjang'
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default TabRikjang;
